<script lang="ts">
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { AvatarPlaceholder } from '@shared/ui/avatar-placeholder';

  import type { NewsFromManyResponse } from '@entities/news';

  import ArticleDetail from './article-detail.svelte';

  export let publicationDate: string | null;
  export let readTime: number | null;
  export let author: NewsFromManyResponse['data'][number]['author'];
</script>

{#if publicationDate || readTime || author}
  {@const authorFullName = `${author?.first_name} ${author?.last_name}`}

  <p class="mb-2.5 flex flex-wrap gap-3 gap-y-1 text-sm font-medium md:mb-4 md:flex-wrap xl:mb-0 xl:leading-8">
    {#if author}
      <div class="flex shrink-0 items-center gap-3">
        <div class="h-8 w-8 shrink-0 overflow-hidden rounded-full md:h-6 md:w-6">
          <DirectusImage
            imageData="{author.avatar}"
            alt="{author.first_name} {author.last_name}"
            pictureSizes="{{
              default: '24px',
            }}"
            presetKeys="{Preset.Mini}"
            loading="lazy"
            imgClasses="w-full h-full object-cover"
          >
            <AvatarPlaceholder slot="default-placeholder" rounded name="{authorFullName}" />
          </DirectusImage>
        </div>

        <span class="hidden md:block">{authorFullName}</span>
      </div>
    {/if}

    <span class="flex flex-col md:hidden">
      {#if author}
        <p>
          {authorFullName}
        </p>
      {/if}

      <ArticleDetail {author} {readTime} {publicationDate} classes="items-center text-xs gap-2 flex" />
    </span>

    <ArticleDetail {author} {readTime} {publicationDate} classes="items-center gap-3 hidden md:flex" />
  </p>
{/if}
